module.exports = __webpack_public_path__ + "img/72ne.0c32d5d3.svg";